import { render } from "./Activity.vue?vue&type=template&id=724b793e&scoped=true"
import script from "./Activity.vue?vue&type=script&lang=ts"
export * from "./Activity.vue?vue&type=script&lang=ts"

import "./Activity.vue?vue&type=style&index=0&id=724b793e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-724b793e"

export default script